import { render, staticRenderFns } from "./precision-editor.vue?vue&type=template&id=2c0c1118&scoped=true&"
import script from "./precision-editor.vue?vue&type=script&lang=js&"
export * from "./precision-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c1118",
  null
  
)

export default component.exports